import { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';

import justLogo from '../images/justlogo500.png';

import BackLinkButton from '../components/BackLinkButton';
import UserHeader from '../components/UserHeader';
import LoaderModal from '../components/LoaderModal'; /////

const MyExchanges = () => {

    const userToken = localStorage.getItem('loggedUser');
    const decodedToken = jwtDecode(userToken);

    // CHIAMATA PER RICEVERE GLI SCAMBI

    const [exchangesArray, setExchangesArray] = useState(null);
    const [isFetchPending, setIsFetchPending] = useState(false);

    const getExchanges = async () => {

        setIsFetchPending(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/userExchanges/${decodedToken.id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    'Content-Type': 'application/json'
                }
            })

            if(response.ok) {
                const exchangesData = await response.json();
                setExchangesArray(exchangesData.payload);
            } else {
                console.log('Error: ', response)
            }
        } catch (error) {
            console.log('Error Type: ', error)
        }

        setIsFetchPending(false);
    }



    useEffect(() => {
        getExchanges();
    }, [])

    useEffect(() => {
        console.log('exchangesArray: ', exchangesArray);
    }, [exchangesArray])

    //

    return (
        <div className="container">
            <img src={justLogo} style={{width: '50px'}}/><h2>I MIEI SCAMBI</h2>
            <BackLinkButton />
            <UserHeader user={{
                id: decodedToken.id,
                avatarUrl: decodedToken.avatar.url,
                name: decodedToken.name,
                surname: decodedToken.surname,
                position: decodedToken.position
            }} />

            <div className="border-box">
                { exchangesArray &&<div className="exchanges-number-box"><h2>Finora hai effettuato <h1 style={{ color: '#C63D2F'}}>{exchangesArray.length}</h1> scambi.</h2></div> }
                {
                    exchangesArray && exchangesArray.map(element => (
                        <div className="exchanges-box">
                            <img src={element.robaObject.photo.resizedUrl} />
                            <p>{element.robaObject.robaName}</p>
                            <div className="exchanges-user-box" style={{ backgroundImage: `url(${element.supplier.avatar.resizedUrl})`, backgroundPosition: 'center', backgroundSize: 'cover'}}>
                                <div className="exchanges-user-info">
                                <h4>Regalato da:</h4>
                                <p>{element.supplier.name}</p>
                                </div>
                            </div>
                            <div className="exchanges-user-box" style={{ backgroundImage: `url(${element.taker.avatar.resizedUrl})`, backgroundPosition: 'center', backgroundSize: 'cover'}}>
                                <div className="exchanges-user-info">
                                <h4>Ricevuto da:</h4>
                                <p>{element.taker.name}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>

            {isFetchPending && <LoaderModal isFetchPending={isFetchPending} />}

        </div>

    )
}

export default MyExchanges;
